import Pica from 'pica';

// note - using 'ww' (web workers) in the features list can cause puzzle-piece distortion of images
// ClickUp ticket: https://app.clickup.com/t/86dwb38h2
const pica = Pica({
  features: ['js', 'wasm']
});

// Have to convert to an image object for pica library
const createOriginal = file => new Promise(resolve => {
  const image = new global.window.Image();
  image.onload = async () => {
    await image.decode();
    resolve(image);
  };
  image.src = global.window.URL.createObjectURL(file);
});

// Going with QuadVGA: 1280x960 - same as iPad
export const calculateDimensions = function calculateDimensions(_ref) {
  let width = _ref.width,
    height = _ref.height;
  let toWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1280;
  let toHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 960;
  const w = parseInt(width, 10);
  const h = parseInt(height, 10);
  const ratio = w / h;
  return ratio > toWidth / toHeight ? {
    width: toWidth,
    height: Math.round(h / (w / toWidth))
  } : {
    width: Math.round(w / (h / toHeight)),
    height: toHeight
  };
};
const createResizedCanvas = image => {
  const _calculateDimensions = calculateDimensions(image),
    width = _calculateDimensions.width,
    height = _calculateDimensions.height;
  const canvas = global.window.document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas;
};
const createBrowserCanvases = async file => {
  const original = await createOriginal(file);
  const resizedCanvas = createResizedCanvas(original);
  return {
    original,
    resizedCanvas
  };
};
const createCanvases = function createCanvases(file) {
  let createServerCanvases = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (global.window === undefined) {
    return createServerCanvases(file);
  }
  return createBrowserCanvases(file);
};
const resizeImage = async function resizeImage(file) {
  let createServerCanvases = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const _await$createCanvases = await createCanvases(file, createServerCanvases),
    original = _await$createCanvases.original,
    resizedCanvas = _await$createCanvases.resizedCanvas;
  const result = await pica.resize(original, resizedCanvas);
  return pica.toBlob(result, 'image/jpeg', 0.7);
};
export default resizeImage;